import React, { useEffect } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import InstructionTitle from '../Instructions/InstructionTitle';
import InstructionContent from '../Instructions/InstructionContent';
import TestInstructions from '../Instructions/TestInstructions';
import Spinner from '../UI/Spinner/Spinner';
import { Divider } from 'antd';
import { fetchTestInfo } from '../../store/actions/AssessmentActions';
import styles from './DynamicTestInstruction.scss';

const DynamicTestInstruction = ({ ctaButton }) => {
  const dispatch = useDispatch();
  const { loading, title, instructions, totalTime, totalProblems, totalMcqs } = useSelector(
    state => state.assessment.testInfo,
  );
  const { test_id: inviteTestId } = useSelector(state => state.invite);
  const { test_id: assessmentTestId } = useSelector(state => state.assessment);

  const totalQuestion = { problems: totalProblems, mcqs: totalMcqs };
  const test_id = inviteTestId || assessmentTestId;

  useEffect(() => {
    if (test_id) {
      dispatch(fetchTestInfo(test_id));
    }
  }, [dispatch, test_id]);

  if (loading) {
    return <Spinner />;
  }

  return (
    <div className={styles['dynamic-test-instruction-container']}>
      <InstructionTitle
        totalQuestion={totalQuestion}
        timer={totalTime}
        title={title}
      />
      {instructions !== '' ? <InstructionContent content={instructions} /> : <TestInstructions />}
      <Divider className={styles['dynamic-test-instruction-divider']} />
      {ctaButton && <div className={styles['c-invite__test-cta']}>{ctaButton}</div>}
    </div>
  );
};

export default DynamicTestInstruction;
